// @generated by packages/platform/shared-system/scripts/generate.ts.

export const NATS_PUBLIC_SUBJECT_TEMPLATES = {
  walletQuoteBalance: "morfi.wallet.{wallet}.quote_balance.v0",
  marketTrade: "morfi.market.{market}.user.{user}.trade.v0",
  marketBoost: "morfi.market.{market}.user.{user}.boost.v0",
  marketBacking: "morfi.market.{market}.user.{user}.backing.v0",
  marketThesisUser: "morfi.market.{market}.user.{user}.thesis.v0",
  marketClaim: "morfi.market.{market}.user.{user}.claim.v0",
  marketBackerFeeClaim: "morfi.market.{market}.backer_fee_claim.v0",
  marketLifecycle: "morfi.market.{market}.lifecycle.v0",
  marketResolution: "morfi.market.{market}.resolution.v0",
  marketOutcomeInitialized: "morfi.market.{market}.outcome.{outcome}.initialized.v0",
  marketCreated: "morfi.market.created.v0",
  marketOutcomeAdd: "morfi.market.{market}.outcome_add.v0",
  scheduledEventUpdated: "morfi.scheduled_event.{schedule}.updated.v0",
  marketGraduated: "morfi.market.graduated.v0",
  marketThesis: "morfi.market.{market}.thesis.v0",
  marketVotes: "morfi.market.{market}.votes.v0",
  marketOutcomeSuggestion: "morfi.market.{market}.outcome_suggestion.v0",
  marketOutcomeSuggestionVoted: "morfi.market.{market}.outcome_suggestion_voted.v0",
  marketOutcomeAdded: "morfi.market.{market}.outcome_added.v0",
  giftEvent: "morfi.gift.{gift}.event.v0",
  userNotifications: "morfi.user.{user}.notifications.v0",
  userGift: "morfi.user.{user}.gift.v0",
  userContentSafety: "morfi.user.{user}.content_safety.v0",
  userOnramp: "morfi.onramp.private.{user}.v0",
  ammActivity: "morfi.amm.{mint}.user.{user}.activity.v0",
  leaderboardRow: "morfi.leaderboard.{kind}.{window}.row.v1",
  confirmedBlockmeta: "morfi.chain.blockmeta.confirmed.latest.v0",
} as const;

export const SUBJECT_WALLET_QUOTE_BALANCE_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.walletQuoteBalance;
export const SUBJECT_MARKET_TRADE_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketTrade;
export const SUBJECT_MARKET_BOOST_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketBoost;
export const SUBJECT_MARKET_BACKING_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketBacking;
export const SUBJECT_MARKET_THESIS_USER_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketThesisUser;
export const SUBJECT_MARKET_CLAIM_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketClaim;
export const SUBJECT_MARKET_BACKER_FEE_CLAIM_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketBackerFeeClaim;
export const SUBJECT_MARKET_LIFECYCLE_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketLifecycle;
export const SUBJECT_MARKET_RESOLUTION_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketResolution;
export const SUBJECT_MARKET_OUTCOME_INITIALIZED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeInitialized;
export const SUBJECT_MARKET_CREATED = NATS_PUBLIC_SUBJECT_TEMPLATES.marketCreated;
export const SUBJECT_MARKET_OUTCOME_ADD_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeAdd;
export const SUBJECT_SCHEDULED_EVENT_UPDATED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.scheduledEventUpdated;
export const SUBJECT_MARKET_GRADUATED = NATS_PUBLIC_SUBJECT_TEMPLATES.marketGraduated;
export const SUBJECT_MARKET_THESIS_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketThesis;
export const SUBJECT_MARKET_VOTES_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketVotes;
export const SUBJECT_MARKET_OUTCOME_SUGGESTION_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeSuggestion;
export const SUBJECT_MARKET_OUTCOME_SUGGESTION_VOTED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeSuggestionVoted;
export const SUBJECT_MARKET_OUTCOME_ADDED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeAdded;
export const SUBJECT_GIFT_EVENT_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.giftEvent;
export const SUBJECT_USER_NOTIFICATIONS_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userNotifications;
export const SUBJECT_USER_GIFT_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userGift;
export const SUBJECT_USER_CONTENT_SAFETY_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userContentSafety;
export const SUBJECT_USER_ONRAMP_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userOnramp;
export const SUBJECT_AMM_ACTIVITY_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.ammActivity;
export const SUBJECT_LEADERBOARD_ROW_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.leaderboardRow;
export const BLOCKMETA_CONFIRMED_SUBJECT = NATS_PUBLIC_SUBJECT_TEMPLATES.confirmedBlockmeta;


export const SDK_ANON_ALLOW_SUBJECTS = ["morfi.wallet.*.quote_balance.v0", "morfi.market.*.>", "morfi.gift.*.>", "morfi.amm.*.>", "morfi.leaderboard.>", "morfi.chain.blockmeta.confirmed.latest.v0"] as const;
export const SDK_USER_ALLOW_SUBJECT_TEMPLATES = ["morfi.user.{user}.notifications.v0", "morfi.user.{user}.gift.v0", "morfi.user.{user}.content_safety.v0", "morfi.onramp.private.{user}.v0"] as const;

export function sdkUserAllowSubjects(user: string): string[] {
  return [
    ...SDK_ANON_ALLOW_SUBJECTS,
    formatSubject("morfi.user.{user}.notifications.v0", { user }),
    formatSubject("morfi.user.{user}.gift.v0", { user }),
    formatSubject("morfi.user.{user}.content_safety.v0", { user }),
    formatSubject("morfi.onramp.private.{user}.v0", { user }),
  ];
}

export function walletQuoteBalanceSubject(wallet: string): string {
  return formatSubject(SUBJECT_WALLET_QUOTE_BALANCE_TEMPLATE, { wallet });
}

export function parseWalletQuoteBalanceSubject(subject: string): { wallet: string } | null {
  const values = parseSubject(SUBJECT_WALLET_QUOTE_BALANCE_TEMPLATE, subject);
  if (values === null) return null;
  const wallet = values.wallet;
  if (wallet === undefined) return null;
  return { wallet };
}

export function marketTradeSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_TRADE_TEMPLATE, { market, user });
}

export function parseMarketTradeSubject(subject: string): { market: string; user: string } | null {
  const values = parseSubject(SUBJECT_MARKET_TRADE_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { market, user };
}

export function marketBoostSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_BOOST_TEMPLATE, { market, user });
}

export function parseMarketBoostSubject(subject: string): { market: string; user: string } | null {
  const values = parseSubject(SUBJECT_MARKET_BOOST_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { market, user };
}

export function marketBackingSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_BACKING_TEMPLATE, { market, user });
}

export function parseMarketBackingSubject(subject: string): { market: string; user: string } | null {
  const values = parseSubject(SUBJECT_MARKET_BACKING_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { market, user };
}

export function marketThesisUserSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_THESIS_USER_TEMPLATE, { market, user });
}

export function parseMarketThesisUserSubject(subject: string): { market: string; user: string } | null {
  const values = parseSubject(SUBJECT_MARKET_THESIS_USER_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { market, user };
}

export function marketClaimSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_CLAIM_TEMPLATE, { market, user });
}

export function parseMarketClaimSubject(subject: string): { market: string; user: string } | null {
  const values = parseSubject(SUBJECT_MARKET_CLAIM_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { market, user };
}

export function marketBackerFeeClaimSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_BACKER_FEE_CLAIM_TEMPLATE, { market });
}

export function parseMarketBackerFeeClaimSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_BACKER_FEE_CLAIM_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function marketLifecycleSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_LIFECYCLE_TEMPLATE, { market });
}

export function parseMarketLifecycleSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_LIFECYCLE_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function marketResolutionSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_RESOLUTION_TEMPLATE, { market });
}

export function parseMarketResolutionSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_RESOLUTION_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function marketOutcomeInitializedSubject(market: string, outcome: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_INITIALIZED_TEMPLATE, { market, outcome });
}

export function parseMarketOutcomeInitializedSubject(subject: string): { market: string; outcome: string } | null {
  const values = parseSubject(SUBJECT_MARKET_OUTCOME_INITIALIZED_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  const outcome = values.outcome;
  if (outcome === undefined) return null;
  return { market, outcome };
}

export function marketOutcomeAddSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_ADD_TEMPLATE, { market });
}

export function parseMarketOutcomeAddSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_OUTCOME_ADD_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function scheduledEventUpdatedSubject(schedule: string): string {
  return formatSubject(SUBJECT_SCHEDULED_EVENT_UPDATED_TEMPLATE, { schedule });
}

export function parseScheduledEventUpdatedSubject(subject: string): { schedule: string } | null {
  const values = parseSubject(SUBJECT_SCHEDULED_EVENT_UPDATED_TEMPLATE, subject);
  if (values === null) return null;
  const schedule = values.schedule;
  if (schedule === undefined) return null;
  return { schedule };
}

export function marketThesisSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_THESIS_TEMPLATE, { market });
}

export function parseMarketThesisSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_THESIS_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function proposalVoteSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_VOTES_TEMPLATE, { market });
}

export function parseProposalVoteSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_VOTES_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function outcomeSuggestionSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_SUGGESTION_TEMPLATE, { market });
}

export function parseOutcomeSuggestionSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_OUTCOME_SUGGESTION_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function outcomeSuggestionVoteSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_SUGGESTION_VOTED_TEMPLATE, { market });
}

export function parseOutcomeSuggestionVoteSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_OUTCOME_SUGGESTION_VOTED_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function outcomeAddedSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_ADDED_TEMPLATE, { market });
}

export function parseOutcomeAddedSubject(subject: string): { market: string } | null {
  const values = parseSubject(SUBJECT_MARKET_OUTCOME_ADDED_TEMPLATE, subject);
  if (values === null) return null;
  const market = values.market;
  if (market === undefined) return null;
  return { market };
}

export function giftEventSubject(gift: string): string {
  return formatSubject(SUBJECT_GIFT_EVENT_TEMPLATE, { gift });
}

export function parseGiftEventSubject(subject: string): { gift: string } | null {
  const values = parseSubject(SUBJECT_GIFT_EVENT_TEMPLATE, subject);
  if (values === null) return null;
  const gift = values.gift;
  if (gift === undefined) return null;
  return { gift };
}

export function userNotificationsSubject(user: string): string {
  return formatSubject(SUBJECT_USER_NOTIFICATIONS_TEMPLATE, { user });
}

export function parseUserNotificationsSubject(subject: string): { user: string } | null {
  const values = parseSubject(SUBJECT_USER_NOTIFICATIONS_TEMPLATE, subject);
  if (values === null) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { user };
}

export function userGiftSubject(user: string): string {
  return formatSubject(SUBJECT_USER_GIFT_TEMPLATE, { user });
}

export function parseUserGiftSubject(subject: string): { user: string } | null {
  const values = parseSubject(SUBJECT_USER_GIFT_TEMPLATE, subject);
  if (values === null) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { user };
}

export function userContentSafetySubject(user: string): string {
  return formatSubject(SUBJECT_USER_CONTENT_SAFETY_TEMPLATE, { user });
}

export function parseUserContentSafetySubject(subject: string): { user: string } | null {
  const values = parseSubject(SUBJECT_USER_CONTENT_SAFETY_TEMPLATE, subject);
  if (values === null) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { user };
}

export function userOnrampSubject(user: string): string {
  return formatSubject(SUBJECT_USER_ONRAMP_TEMPLATE, { user });
}

export function parseUserOnrampSubject(subject: string): { user: string } | null {
  const values = parseSubject(SUBJECT_USER_ONRAMP_TEMPLATE, subject);
  if (values === null) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { user };
}

export function ammActivitySubject(mint: string, user: string = "*"): string {
  return formatSubject(SUBJECT_AMM_ACTIVITY_TEMPLATE, { mint, user });
}

export function parseAmmActivitySubject(subject: string): { mint: string; user: string } | null {
  const values = parseSubject(SUBJECT_AMM_ACTIVITY_TEMPLATE, subject);
  if (values === null) return null;
  const mint = values.mint;
  if (mint === undefined) return null;
  const user = values.user;
  if (user === undefined) return null;
  return { mint, user };
}

export function leaderboardRowSubject(kind: string, window: string): string {
  return formatSubject(SUBJECT_LEADERBOARD_ROW_TEMPLATE, { kind, window });
}

export function parseLeaderboardRowSubject(subject: string): { kind: string; window: string } | null {
  const values = parseSubject(SUBJECT_LEADERBOARD_ROW_TEMPLATE, subject);
  if (values === null) return null;
  const kind = values.kind;
  if (kind === undefined) return null;
  const window = values.window;
  if (window === undefined) return null;
  return { kind, window };
}

function formatSubject(template: string, values: Readonly<Record<string, string>>): string {
  return template.replace(/\{([a-z][a-zA-Z0-9]*)\}/gu, (_, rawName: string) => {
    const value = values[rawName];
    if (value === undefined) throw new Error("missing subject token " + rawName);
    return assertSubjectToken(rawName, value);
  });
}

function parseSubject(template: string, subject: string): Record<string, string> | null {
  const templateParts = template.split(".");
  const subjectParts = subject.split(".");
  if (templateParts.length !== subjectParts.length) return null;
  const values: Record<string, string> = {};
  for (let i = 0; i < templateParts.length; i += 1) {
    const token = templateParts[i];
    const actual = subjectParts[i];
    if (token === undefined || actual === undefined || actual.length === 0) return null;
    if (token.charAt(0) === "{" && token.charAt(token.length - 1) === "}") {
      values[token.slice(1, -1)] = actual;
      continue;
    }
    if (token !== actual) return null;
  }
  return values;
}

function assertSubjectToken(name: string, value: string): string {
  if (value.trim() === "") throw new Error("subject token " + name + " must be non-empty");
  if (value.includes(".")) throw new Error("subject token " + name + " must not contain dots");
  return value;
}
